import {useSettingsQuery} from '../../../common/providers/ApiInterface'
import {UNASSIGNED_DEPARTMENT_CODE} from '../../consts'

export const useDepartmentTypes = (areaTypeId?: string) => {
  return useSettingsQuery('upmDepartmentTypes', [], {
    gcTime: 0,
    retry: false,
    staleTime: 0,
    enabled: !!areaTypeId,
    select: (data) =>
      data.filter(
        (type) => type.code !== UNASSIGNED_DEPARTMENT_CODE && type.areaTypeId === areaTypeId
      )
  })
}

export const QueryKey = 'upmDepartmentTypes'
